import React, { useState, useEffect } from 'react';


const WeatherDataInput = ({ onOptionChange, setShowTiff, isSynoptic, onTiffTypeChange, spiValue, spiSeasonalValue }) => {
  const [isDaily, setIsDaily] = useState(false);
  const [isMountly, setIsMountly] = useState(false);
  const [isHourly, setIsHourly] = useState(true);
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    if (isSynoptic) {
      setActive('daily');
    }
  }, [isSynoptic]);


  const synopticExtraOptions = [
    { value: 'ff_10m_dmax', label: 'بیشینه سرعت باد' },
    { value: 'dd_10m_dmax', label: 'جهت باد بیشینه' },
    { value: 'ff_10m_dm', label: 'میانگین سرعت باد' },
    { value: 'd2m_dm', label: 'میانگین روزانه دمای نقطه شبنم' },
    { value: 'skt_dmin', label: 'کمینه روزانه دمای خاک' },
    { value: 'mx2t', label: 'بیشینه روزانه دما' },
    { value: 'mn2t', label: 'کمینه روزانه دما' },
    { value: 't2m_dm', label: 'میانگین روزانه دما' },
    { value: 'tp_dsum', label: 'بارش روزانه' },
    { value: 'rh2m_dm', label: 'میانگین روزانه رطوبت' },
    { value: 'rh2m_dmax', label: 'بیشینه روزانه رطوبت' },
    { value: 'rh2m_dmin', label: 'کمینه روزانه رطوبت' },
    { value: 'sshn_dsum', label: 'ساعت آفتابی' },
    { value: 'e_dsum', label: 'تبخیر و تعرق روزانه' },
    { value: 'ss_dsum', label: 'ارتفاع برف روزانه' },
  ];


  const dailyOptions = [
    { value: 't2m_dmax', label: 'بیشینه روزانه دما' },
    { value: 'rh2m_dmax', label: 'بیشینه روزانه رطوبت' },
    { value: 't2m_dmin', label: 'کمینه روزانه دما' },
    { value: 'rh2m_dmin', label: 'کمینه روزانه رطوبت' },
    { value: 'tp_dsum', label: 'بارش روزانه' },
    { value: 'ssrd_dsum', label: 'تشعشع روزانه' },
    { value: 'sshn_dsum', label: 'ساعت آفتابی' },
    { value: 'e_dsum', label: 'تبخیر و تعرق روزانه' },
    { value: 'sde-dsum', label: 'ارتفاع برف روزانه' },
    { value: 'cu_dacc', label: 'نیاز سرمایی' },
    { value: 'rh2m_dm', label: 'میانگین روزانه رطوبت' },
    { value: 't2m_dm', label: 'میانگین روزانه دما' },
  ];

  const filteredDailyOptions = isSynoptic
    ? synopticExtraOptions
    : dailyOptions;

  const hourlyOptions = [
    { value: 't2m', label: 'دما' },
    { value: 'tp', label: 'بارش' },
    { value: 'skt', label: 'دمای سطح خاک' },
    { value: 'fg10', label: 'سرعت باد گاستی' },
    { value: 'ws', label: 'پدیده جوی' },
  ];

  const mountlyOptions = [
    { value: 'spi', label: 'SPI ماهانه' },
    { value: 'spi-3m', label: 'SPI فصلی' },
    { value: 'cu', label: 'نیاز سرمایی' },
  ];

  const handleCheckboxChange = (option, optionsGroup) => {
    setSelectedOptions((prev) => {
      let updated;

      if (optionsGroup === "mountly") {
        // فقط همون یکی که تازه انتخاب شده
        updated = [option];

        // ریست نمایش‌های قبلی
        setShowTiff(false);

        if (option === "spi") {
          setShowTiff(spiValue !== null);
          if (spiValue !== null) onTiffTypeChange("SPI");
        }
        if (option === "cu") {
          setShowTiff(true);
          onTiffTypeChange("CU");
        }
        if (option === "spi-3m") {
          setShowTiff(spiSeasonalValue !== null);
          if (spiSeasonalValue !== null) onTiffTypeChange("SPI-3M");
        }
      } else {
        // بقیه گروه‌ها رو مثل قبل می‌ذاریم
        if (prev.includes(option)) {
          updated = prev.filter((o) => o !== option);
        } else {
          updated = [...prev, option];
        }
        setShowTiff(false);
      }

      onOptionChange(updated);
      return updated;
    });
  };


  const renderCheckboxes = (options, gridCols, groupName) => (
    <div className={`grid ${gridCols} gap-x-4 gap-y-2 w-full lg:w-[75%] mx-auto`}>
      {options.map(({ value, label }) => (
        <label key={value} className="flex font-emoji items-center gap-2 mb-2 text-sm">
          <input
            type="checkbox"
            className="w-4 h-4"
            checked={selectedOptions.includes(value)}
            onChange={() => handleCheckboxChange(value, groupName)}
          />
          {label}
          {value === 'spi' && spiValue !== null && (
            <>
              <span>=</span>
              <span dir='ltr' className="text-xl">{spiValue}</span>
            </>
          )}
          {value === 'spi-3m' && spiSeasonalValue !== null && (
            <>
              <span>=</span>
              <span dir='ltr' className="text-xl">{spiSeasonalValue}</span>
            </>
          )}
        </label>
      ))}
    </div>
  );


  const setActive = (mode) => {
    setIsDaily(mode === 'daily');
    setIsHourly(mode === 'hourly');
    setIsMountly(mode === 'mountly');
  };

  return (
    <div className="w-full flex flex-col items-center mb-4">
      <div className="flex gap-2 mb-8">
        <button
          className={`px-4 py-2 rounded-md text-sm font-medium 
        ${isHourly ? 'bg-[#02bfe7] text-white' : 'bg-white text-black border'} 
        ${isSynoptic ? 'opacity-40 bg-gray-200 cursor-not-allowed' : ''}`}
          onClick={() => !isSynoptic && setActive('hourly')}
          disabled={isSynoptic}
        >
          ساعتی
        </button>
        <button
          className={`px-4 py-2 rounded-md text-sm font-medium ${isDaily ? 'bg-[#02bfe7] text-white' : 'bg-white text-black border'}`}
          onClick={() => setActive('daily')}
        >
          روزانه
        </button>
        <button
          className={`px-4 py-2 rounded-md text-sm font-medium 
        ${isMountly ? 'bg-[#02bfe7] text-white' : 'bg-white text-black border'} 
        ${isSynoptic ? 'opacity-40 bg-gray-200 cursor-not-allowed' : ''}`}
          onClick={() => !isSynoptic && setActive('mountly')}
          disabled={isSynoptic}
        >
          ماهانه
        </button>
      </div>

      {isDaily && renderCheckboxes(filteredDailyOptions, 'grid-cols-6', 'daily')}
      {isHourly && renderCheckboxes(hourlyOptions, 'grid-cols-5', 'hourly')}
      {isMountly && renderCheckboxes(mountlyOptions, 'grid-cols-3', 'mountly')}

    </div>
  );
};

export default WeatherDataInput;
